import router from "@/router/index";

export default function admin({next, store}) {
    let user = store.getters.getUser;
    // console.log(user.role);
    if (!user || user.role !== 'admin') {
        store.dispatch('logout_user');
        router.push({
            name: "Login"
        });
    }
    return next()
}
